/**
 * Shared CLI model options + thinking levels for chat session creation.
 * Consumed by web (ChatSessionCreationModal) and mobile (ChatSessionCreationSheet).
 */

export interface CliModelOption {
  value: string;
  label: string;
  provider: 'claude' | 'codex';
}

export const CLI_MODELS: readonly CliModelOption[] = [
  { value: 'gpt-6-astra', label: 'GPT-6 Astra', provider: 'codex' },
  { value: 'gpt-6-sol', label: 'GPT-6 Sol', provider: 'codex' },
  { value: 'gpt-6-luna', label: 'GPT-6 Luna', provider: 'codex' },
] as const;

export interface ThinkingLevelOption {
  value: string;
  label: string;
}

export const THINKING_LEVELS: readonly ThinkingLevelOption[] = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
  { value: 'xhigh', label: 'Extra High' },
] as const;

export const OPUS_ONLY_EFFORTS: ReadonlySet<string> = new Set();

export const DEFAULT_CLI_MODEL = 'gpt-6-sol';
export const DEFAULT_CODEX_MODEL = 'gpt-6-sol';
/** Default model for the `claude_code` chat backend (the host Claude Code runner). */
export const DEFAULT_CLAUDE_CODE_MODEL = 'claude-opus-5';
export const DEFAULT_EFFORT_LEVEL = 'high';

export function getProviderForCliModel(modelValue: string): CliModelOption['provider'] {
  return CLI_MODELS.find(model => model.value === modelValue)?.provider ?? 'codex';
}

export function isOpusModel(modelValue: string): boolean {
  return modelValue.startsWith('claude-opus');
}

/** Preserve the previous API; all current CLI models support every effort level. */
export function downgradeEffortForModel(currentEffort: string, _modelValue: string): string {
  if (OPUS_ONLY_EFFORTS.has(currentEffort)) {
    return 'high';
  }
  return currentEffort;
}
